import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect as ReduxConnect } from 'react-redux';
import { connect as ModalConnect } from '../../providers/modal';
import Summary from '../ModalThemeSummary';
import CommentsSummaryToSubmitModalTrigger from '../CommentsSummaryToSubmitModalTrigger';
import CommentsSummaryToSubmitModalBody from '../CommentsSummaryToSubmitModalBody';
import CommentsSummaryToSubmitModalFooter from '../CommentsSummaryToSubmitModalFooter';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as Translations from '../../providers/i18n';

class CommentsSummaryToSubmitModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            commentsSummaryMessage: props.i18n.t('attachments_preview.comments_summary_modal.default_text',
                { senderUsername: props.currentCollaboratorUsername, recipientUsername: props.recipientCollaboratorUsername })
        };
    }

    setCommentsSummaryMessage = (e) => this.setState({ commentsSummaryMessage: e.target.value })

    render() {
        const {
            commentsSummaryMessage
        } = this.state;

        const {
            i18n
        } = this.props;

        return (
            <Summary name="comments-summary-modal attachments_preview-package order_page_perseus"
                trigger={({ open }) => <CommentsSummaryToSubmitModalTrigger open={open}/>}
                onClose={this.props.close}
                header={i18n.t('attachments_preview.comments_summary_modal.title')}
                footer={({ close }) => <CommentsSummaryToSubmitModalFooter commentsSummaryMessage={commentsSummaryMessage} close={close}/>}>
                {() => <CommentsSummaryToSubmitModalBody setCommentsSummaryMessage={this.setCommentsSummaryMessage} commentsSummaryMessage={commentsSummaryMessage}/>}
            </Summary>
        );
    }
}

CommentsSummaryToSubmitModal.propTypes = {
    currentCollaboratorUsername: PropTypes.string,
    recipientCollaboratorUsername: PropTypes.string,
    close: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

CommentsSummaryToSubmitModal.defaultProps = {
    currentCollaboratorUsername: '',
    recipientCollaboratorUsername: '',
    close: () => null
};

const mapStateToProps = (state) => ({
    currentCollaboratorUsername: CollaboratorsSelectors.getCurrentCollaboratorUsername(state),
    recipientCollaboratorUsername: CollaboratorsSelectors.getNotCurrentCollaboratorUsernameInSellerGroup(state)
});

export default compose(
    Translations.connect,
    ModalConnect,
    ReduxConnect(mapStateToProps)
)(CommentsSummaryToSubmitModal);
